const Navbar = () => {
  return (
    <nav class="navbar navbar-light bg-warning">
      <span class="navbar-brand ml-4 mb-0 h1">Pomodoro</span>
    </nav>
  );
};

export default Navbar;
